<template>
  <div class="msgtypeWeapp">
    <div class="msgtypeWeapp_box">
      <div class="weapp_top">
        <div class="weapp_title">
          <div class="weapp_icon"><img :src="g_imgSrc.dialogueIcon" alt="" /></div>
          <span>{{ items.content.displayname }}</span>
        </div>
        <h3>{{ items.content.title }}</h3>
        <div class="weapp_img">
          <img
            src="https://baike-med-1256891581.file.myqcloud.com/2021034/c03485a0-8608-11eb-947c-032fa08bea6e_0.png"
            alt=""
          />
        </div>
      </div>
      <p>小程序</p>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.msgtypeWeapp {
  padding: 0 12px;
  box-sizing: border-box;
  .msgtypeWeapp_box {
    width: 220px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background: #ffffff;
    .weapp_top {
      padding: 10px;
      width: 100%;
      box-sizing: border-box;
      .weapp_title {
        display: flex;
        .weapp_icon {
          width: 20px;
          height: 20px;
          background: #2f96ff;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 10px;
            height: 10px;
            font-size: 0;
          }
        }
        span {
          font-size: 12px;
          color: #909399;
          line-height: 22px;
          margin-left: 8px;
        }
      }
      h3 {
        font-size: 14px;
        color: #303133;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 100;
      }
      .weapp_img {
        width: 100%;
        height: 170px;
        background: #f5f7fa;
        border-radius: 4px;
        img {
          width: 100%;
          height: 170px;
          font-size: 0;
        }
      }
    }
    p {
      font-size: 12px;
      color: #909399;
      line-height: 24px;
      border-top: 1px solid rgba(0, 0, 0, 0.08);
      padding: 0 10px;
    }
  }
}
</style>
